import { gql, useQuery } from '@apollo/client';

export const GET_PROCESS_BY_ID = gql`
  query getProcessById($processId: ObjectId!) {
    getProcessById(processId: $processId) {
      _id
      title
      processTasks {
        _id
        _id
        title
        details
        createdBy
        assignTo
        responsiblePersonsIds
        dueTo
        status
        type
        jobId
        companyId
        departmentId
        description
        overdue
        checklist {
          title
          completed
        }
      }
    }
  }
`;

export const useGetProcessById = (processId?: string) => {
  const { data, loading } = useQuery(GET_PROCESS_BY_ID, {
    variables: { processId },
    skip: !processId,
    fetchPolicy: 'network-only',
  });

  return {
    process: data?.getProcessById || {},
    loading,
  };
};
